// Products whose configurator can take a preselected fabric (?fabric=<colorId>).
export const CONFIG_PRODUCTS = {
  'roller-shades': 'Roller Shades',
  'solar-shades': 'Solar Shades',
  'cellular-shades': 'Cellular Shades',
  'zebra-shades': 'Zebra Shades',
  'roman-shades': 'Roman Shades',
};

// Primary product (chosen server-side) + any other configurators offering the fabric.
export const productsFor = (c) => ({ primary: c.primary_product, others: (c.products || []).filter((t) => t !== c.primary_product) });

export const configureUrl = (type, c) => `/products/${type}?fabric=${encodeURIComponent(c.id)}`;
